// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"183":"Service","268":"Home","362":"Dashboard","438":"Login","616":"Policy","683":"recharge","939":"Purchase"}[chunkId] || chunkId) + "." + {"183":"ab0fb588","268":"e4ade6d9","362":"4947f601","438":"91dfc08b","616":"958fa70e","683":"32e58369","906":"ad04ab78","939":"dcc8a708"}[chunkId] + ".css";
};